import React, { Component } from 'react';
import { Route, Switch } from "react-router-dom";

import Home from './Home';
import About from './About';
import Programs from './Programs';
import Subjects from './Subjects';
import Media from './Media';
import Links from './Links';
import Events from './Events';
import Contact from './Contact';




class Routes extends Component {

  render() {
    return (
      <div>

        <Switch>
          <Route path="/home" component={Home}/>
          <Route path="/about" component={About}/>
          <Route path="/media" component={Media}/>
          <Route path="/programs/:subroute" component={Programs}/>
          <Route path="/programs" component={Programs}/>
          <Route path="/subjects" component={Subjects}/>
          <Route path="/links" component={Links}/>
          <Route path="/events" component={Events} />
          <Route path="/contact" component={Contact} />
          <Route exact path="/" component={Home}/> 
        </Switch>
      </div>
    )
  }
}

Routes.propTypes = {
}

export default Routes;
